const path = window.require("path");
const { app } = window.require("@electron/remote");
const protobuf = window.require("protobufjs");

function getRoot() {
  if (path && app && protobuf) {
    const communicationPath = path.join(
      app.getAppPath(),
      "modules/push-notification-protobuf/push-notification.proto"
    );
    const protoRoot = protobuf.loadSync(communicationPath);

    return protoRoot;
  }

  return new Proxy(
    {},
    {
      get(obj, prop) {
        if (window.pushNotificationRoot) {
          return window.pushNotificationRoot[prop];
        }

        if (prop === "lookupType") return () => undefined;
        if (prop === "lookupEnum") return () => undefined;
        return undefined;
      }
    }
  );
}

const protoRoot = getRoot();

export default protoRoot;

const Type = {
  get PushNotification() {
    return protoRoot.lookupType("pushNotification.PushNotification");
  },
  get IOSPushNotification() {
    return protoRoot.lookupType("pushNotification.IOSPushNotification");
  },
  get AndroidPushNotification() {
    return protoRoot.lookupType("pushNotification.AndroidPushNotification");
  }
};

export { Type };
